import type { Message } from '../Interfaces/Message';

export class AasRequestError extends Error {
  constructor(
    public readonly request: Request,
    public readonly response: Response,
    public readonly messages?: Message[],
  ) {
    super(`Request to AAS API at ${request.url} failed with status ${response.status}`);
  }
}
